import { useParams } from 'react-router-dom';
import { useJob } from '../state';
import { Run } from '../components/run';
import { LeftNav } from '../components/nav';
import { FaCheckCircle } from 'react-icons/fa';
import { Loading } from '../components/loading';
import { Args, Progress, ItemsTable, Cost, Artifacts } from '../components/job';
import { colors, headerHeight } from '../constants';

const UrlsList = ({ urls }) => (
  <div style={{ width: '100%', overflow: 'hidden' }}>
    <b>{urls.length}</b> URLs
    <ul>
      {urls.map((it) => (
        <li>{it}</li>
      ))}
    </ul>
  </div>
);

const CrawlJob = ({ job }) => {
  const pattern = job?.args?.pattern || '';

  return (
    <div>
      <h3>Arguments</h3>
      <Args job={job} />

      <h3>Progress</h3>
      <Progress job={job} />

      <h3>Cost</h3>
      <Cost job={job} showPercent />

      <h3>Results</h3>
      <UrlsList urls={job?.results?.hits || []} />
    </div>
  );
};

const ExtractJob = ({ job }) => {
  return (
    <div>
      <h3>Arguments</h3>
      <Args job={job} />

      <h3>Progress</h3>
      <Progress job={job} />

      <h3>Cost</h3>
      <Cost job={job} />

      <h3>Results</h3>
      <ItemsTable items={job.results?.items || []} />

      <h3>Artifacts</h3>
      <Artifacts artifacts={job.artifacts || []} />
    </div>
  );
};

const ScrapeJob = ({ job }) => {
  return (
    <div>
      <h3>Arguments</h3>
      <Args job={job} />

      <h3>Progress</h3>
      <Progress job={job} />

      <h3>Cost</h3>
      <Cost job={job} />

      <h3>Results</h3>
      <ItemsTable items={job.results?.items || []} />
      <UrlsList urls={job?.results?.hits || []} />

      <h3>Artifacts</h3>
      <Artifacts artifacts={job.artifacts || []} />
    </div>
  );
};

const JsonJob = ({ job }) => (
  <div>
    <pre>{JSON.stringify(job, null, 2)}</pre>
  </div>
);

export default function Job() {
  const { id } = useParams();
  const { loading, job } = useJob(id);

  const innerFn = {
    crawl: CrawlJob,
    extract: ExtractJob,
    scrape: ScrapeJob,
  }[job?.name];

  const inner = (innerFn || JsonJob)({ job });

  return (
    <LeftNav>
      <div
        style={{
          position: 'sticky',
          display: 'flex',
          alignItems: 'center',
          gap: 5,
          top: headerHeight + 10,
          width: '100%',
          background: 'white',
          padding: 10,
          marginBottom: 10,
          border: '1px solid #ccc',
          borderRadius: 4,
          zIndex: 2,
        }}
      >
        {!job && <Loading size="xs" />}
        {job && job?.state == 'active' && <Loading size="xs" />}
        {job && job?.state == 'completed' && (
          <div
            style={{
              color: colors.green,
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <FaCheckCircle />
          </div>
        )}
        {job && (
          <div>
            <b>
              {job?.name || 'job'} {id}
            </b>
          </div>
        )}
        {job && <div>- {job?.state}</div>}
      </div>

      {loading && <div>Loading...</div>}
      {inner}

      {/*
      <pre>JOB:{JSON.stringify(job, null, 2)}</pre>
       */}
    </LeftNav>
  );
}
